"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ClientServiceUrls = require("./ClientServiceUrls");
Object.keys(_ClientServiceUrls).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ClientServiceUrls[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ClientServiceUrls[key];
    }
  });
});
var _ErrorPageTranslationKey = require("./ErrorPageTranslationKey");
Object.keys(_ErrorPageTranslationKey).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErrorPageTranslationKey[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ErrorPageTranslationKey[key];
    }
  });
});
var _ErrorPageTranslations = require("./ErrorPageTranslations");
Object.keys(_ErrorPageTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErrorPageTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ErrorPageTranslations[key];
    }
  });
});
var _SupportedErrorCode = require("./SupportedErrorCode");
Object.keys(_SupportedErrorCode).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SupportedErrorCode[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SupportedErrorCode[key];
    }
  });
});
var _SerializableError = require("./SerializableError");
Object.keys(_SerializableError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SerializableError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SerializableError[key];
    }
  });
});
